import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import reducers, { createInitialState } from './reducers';
import { syncWithLocalStorage } from './subscriptions';
import { getSessionId, getSessionData } from '../modules/SessionStore';

const getInitialState = () => {
  const session_id = getSessionId();
  const sessionData = getSessionData({});
  return {
    ...createInitialState({ session_id }),
    // todo - move the below into session generation methods too
    bookForm: {
      stage: {
        stage: sessionData.stage,
      },
      completedFields: {
        completed: sessionData.progress,
      },
      bookInputs: {
        current: sessionData.data,
      },
    },
  };
};

export default () => {
  // dev tools composer
  let composer =
    typeof window === 'object'
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : null;
  if (!composer) {
    composer = compose;
  }

  const middleware = [thunk];

  // get initial state to hydrate the store
  const initialState = getInitialState();

  // create the store
  const store = createStore(
    combineReducers({
      ...reducers,
    }),
    initialState,
    composer(applyMiddleware(...middleware))
  );

  // notify store subscribers
  // todo - tidy this up using prototypes
  store.subscribe(() => {
    syncWithLocalStorage(store.getState);
  });

  return store;
};
